import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColGroupDef, ICellRendererParams } from "ag-grid-enterprise";
import { ElectrodeEvent } from "../../../../models/eaf.models";
import { EditAndDeleteButtons } from "../../components/EditAndDeleteButtons";

type Props = {
	deleteElectrodeEvent: (electrodeEventId: number) => void;
	editElectrodeEvent: (electrodeEventId: number) => void;
};

export const useTableData = ({
	deleteElectrodeEvent,
	editElectrodeEvent,
}: Props) => {
	const columns: ColGroupDef[] = [
		{
			headerName: "Electrodes",
			children: [
				{
					field: "Phase",
					headerName: "Phase",
					flex: 1,
					minWidth: 61,
				},
				{
					field: "Timestamp",
					headerName: "Time",
					flex: 1,
					minWidth: 59,
					valueGetter: (params: any) => {
						if (params.data.Timestamp) {
							return dxtToLocalServerTime(params.data.Timestamp, "HH:mm");
						}
					},
				},
				{
					field: "PhaseEventType",
					headerName: "Event",
					flex: 3,
					minWidth: 50,
					wrapText: true,
					autoHeight: true,
				},
				{
					field: "actions",
					headerName: " ",
					flex: 1,
					minWidth: 80,
					maxWidth: 80,
					cellRenderer: EditAndDeleteButtons,
					cellRendererParams: (params: ICellRendererParams) => ({
						deleteItem: deleteElectrodeEvent,
						edit: editElectrodeEvent,
						id: (params.data as ElectrodeEvent).ElectrodeEventId,
					}),
				},
			],
		},
	];

	return { columns };
};
